<template>
  <recurring-orders-reports-view :userId="getUserIdFromQueryParams()" />
</template>

<script>
import RecurringOrdersReportsView from "../components/reports/RecurringOrdersReportsView.vue";

export default {
  components: { RecurringOrdersReportsView },
  name: "RecurringOrdersReport",

  methods: {
    getUserIdFromQueryParams() {
      return this.$route.params.id;
    },
  },
};
</script>

<style scoped>
</style>
